<template>
  <div>
    <button class="btn btn-warning" @click="filedownload">
      <slot></slot>
      <i class="fa fa-download"></i>
    </button>
    <!-- 超链接的设置 -->
    <div class="modal" ref="fileModal">
      <div class="modal-dialog" >
        <div class="modal-content" style="top: 25%!important">
          <div class="modal-header">
            <h4 class="text-danger">警告</h4>
          </div>
          <div class="modal-body">
            <p class="text-danger">请点击右上角以后，再浏览器中打开并下载</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["href"],
  data() {
    return {};
  },
  methods: {
    filedownload(e) {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        $(this.$refs.fileModal).modal("show");
      } else {
        const a = document.createElement("a");
        a.download = "";
        a.href = this.href;
        a.click();
      }
    },
    isPC() {
      //判断是否是微信内置浏览器 如果是的我 就浏览器
      // const userAgentInfo = navigator.userAgent; // 平台获取
      // const Agents = [ // 平台列表
      //   "Android",
      //   "iPhone",
      //   "SymbianOS",
      //   "Windows Phone",
      //   "iPad",
      //   "iPod"
      // ];
      // var flag = true;
      // for (let v = 0; v < Agents.length; v++) {
      //   if (userAgentInfo.indexOf(Agents[v]) > 0) {
      //     flag = false;
      //     break;
      //   }
      // }
      // return flag;
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/base/filedownload.vue